import styled, { keyframes } from 'styled-components';
import { Color } from '@pushwoosh/kit-constants';
import { SizeInPxBySpinnerSizeMap } from './spinner.maps';
const rotate = keyframes(["from{transform:rotate(0deg);}to{transform:rotate(360deg);}"]);
export const SpinnerBox = styled.div.withConfig({
  displayName: "SpinnerBox",
  componentId: "sc-1a2cq5s-0"
})(["width:", ";height:", ";line-height:0;color:", ";user-select:none;"], ({
  size
}) => SizeInPxBySpinnerSizeMap[size], ({
  size
}) => SizeInPxBySpinnerSizeMap[size], ({
  color
}) => color || Color.CURRENT);
export const SpinnerAnimate = styled.div.withConfig({
  displayName: "SpinnerAnimate",
  componentId: "sc-1a2cq5s-1"
})(["line-height:0;animation:", " 0.5s linear infinite;"], rotate);
SpinnerBox.displayName = 'SpinnerBox';
SpinnerAnimate.displayName = 'SpinnerAnimate';